import { FeatureFlag } from '../FeatureFlag';

export const enableOrderDebugFiltering = new FeatureFlag({
    key: 'enable-order-debug-filtering',
    createdOn: '2025-04-07',
    defaultValue: false,
});
